// @flow

import * as React from 'react';
import Box from 'sail/Box';
import classNames from 'classnames';

type NextStepsProps = {|
  className?: string,
  children: React.Node,
|};

export const NextSteps = ({className, children}: NextStepsProps) => (
  <Box className={classNames('NextSteps', className)}>{children}</Box>
);
